import React from "react";

interface FormSectionLoadingSkeletonProps {
  rows?: number;
  className?: string;
}

export default function FormSectionLoadingSkeleton({
  rows = 6,
  className = "",
}: FormSectionLoadingSkeletonProps) {
  return (
    <div
      className={`space-y-3 ${className}`.trim()}
      role="status"
      aria-live="polite"
    >
      <span className="sr-only">Loading</span>
      <div className="h-4 w-44 animate-pulse rounded bg-[#E2E8F0]" />
      {Array.from({ length: rows }, (_, index) => (
        <div
          key={index}
          className="h-11 animate-pulse rounded-xl bg-[#EFF6FF]"
        />
      ))}
    </div>
  );
}
